if (window.location.pathname === '/pages/giving-back' || window.location.pathname === '/pages/giving-back-lp') {
	// console.log('DOCUMENT REFERRER:', document.referrer, 'URL:', window.location.href);
	if (!document.referrer.match(/^https?:\/\/([^\/]+\.)?ecoflow\.com(\/|$)/i) && !Shopify.designMode) {
	  window.location.replace('https://ca.ecoflow.com');
	}
}